<template>
  <el-container class="mobile-preference" direction="vertical">
    <div v-show="showOverlay" class="mobile-overlay"></div>
    <el-main class="preference-info-container">
      <div
        v-for="(preferenceItem, index) in preferenceList"
        v-clickoutside="preferenceItem.selectOutsideClickHandler"
        class="info-line"
        :key="index"
        :class="`${preferenceItem.name}-line`">
        <div class="line-icon" @click="handleSelectClick(preferenceItem)">
          <i class="iconfont" :class="preferenceItem.icon"></i>
        </div>
        <div class="line-label" @click="handleSelectClick(preferenceItem)">
          <div class="preference-label">{{ preferenceItem.label }}</div>
          <div v-if="preferenceItem.type !== 'link'" class="select-label">{{ getSelectLabel(preferenceItem) }}</div>
        </div>
        <div class="line-arrow" @click="handleSelectClick(preferenceItem)">
          <i
            :class="[
              preferenceItem.showOptionList ? 'el-icon-arrow-up' : 'el-icon-arrow-down',
              preferenceItem.type === 'link' && 'el-icon-arrow-right'
            ]"
          ></i>
        </div>
        <div class="select-option-list" :ref="`${preferenceItem.name}OptionList`">
          <div
            v-for="(item, index) in preferenceItem.optionList"
            v-show="item.show"
            class="option-item"
            :key="index"
            @click="handleOptionItemClick(preferenceItem, item)">
            {{ item.label }}
          </div>
        </div>
      </div>
    </el-main>
    <el-footer class="footer-btn-group" height="25px">
      <div
        class="back-btn"
        :style="customBackBtnStyle"
        @click="handleBackBtnClick">
        {{ $t('survey.btn.back') }}
      </div>
      <div
        class="next-btn"
        :style="customSaveBtnStyle"
        @click="handleSaveBtnClick">
        {{ $t('survey.btn.save') }}
      </div>
    </el-footer>
  </el-container>
</template>

<script>
import _ from 'lodash'
import Clickoutside from 'element-ui/src/utils/clickoutside'

export default {
  directives: {
    Clickoutside
  },
  props: {
    stepList: {
      type: Array,
      default: () => []
    },
    companyCustomColor: {
      required: true
    },
    preference: {
      type: Object,
      required: true
    },
    preferenceList: {
      type: Array,
      required: true
    },
    showOverlay: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {

    }
  },
  computed: {
    customBackBtnStyle () {
      return {
        borderColor: this.companyCustomColor,
        color: this.companyCustomColor
      }
    },
    customSaveBtnStyle () {
      return {
        backgroundColor: this.companyCustomColor,
        color: this.getTextColorByBgColor(this.companyCustomColor)
      }
    }
  },
  created () {
    _.forEach(this.preferenceList, item => {
      item.selectOutsideClickHandler = () => {
        this.handleSelectClickOutside(item)
      }
    })
  },
  methods: {
    getSelectLabel (preferenceItem) {
      const optionItem = _.find(preferenceItem.optionList, { value: this.preference[preferenceItem.dataKey] })
      return optionItem && optionItem.label
    },
    setOptionListAntimation (preferenceItem) {
      const optionList = this.$refs[`${preferenceItem.name}OptionList`][0]
      if (preferenceItem.showOptionList) {
        optionList.style.display = 'block'
        setTimeout(() => {
          optionList.classList.add('move-in')
        }, 0)
      } else {
        optionList.classList.remove('move-in')
        setTimeout(() => {
          if (preferenceItem.showOptionList) {
            optionList.style.display = 'block'
          } else {
            optionList.style.display = 'none'
          }
        }, 500)
      }
    },
    handleSelectClick (preferenceItem) {
      if (preferenceItem.type === 'link') {
        const link = preferenceItem.link
        if (preferenceItem.isInclude) {
          this.$router.push(link)
        } else {
          window.location.href = link
        }
      } else {
        preferenceItem.showOptionList = !preferenceItem.showOptionList
        this.setOptionListAntimation(preferenceItem)
      }
    },
    handleSelectClickOutside (preferenceItem) {
      if (preferenceItem.showOptionList) {
        preferenceItem.showOptionList = false
        this.setOptionListAntimation(preferenceItem)
      }
    },
    handleOptionItemClick (preferenceItem, optionItem) {
      this.preference[preferenceItem.dataKey] = optionItem.value
      preferenceItem.showOptionList = false
      this.setOptionListAntimation(preferenceItem)
    },
    handleBackBtnClick () {
      this.$emit('back')
    },
    handleSaveBtnClick () {
      this.$emit('save')
    },
    getTextColorByBgColor (bgColor) {
      if (!bgColor) {
        return
      }
      bgColor = bgColor.replace('#', '')
      const r = parseInt(bgColor.substr(0, 2), 16)
      const g = parseInt(bgColor.substr(2, 2), 16)
      const b = parseInt(bgColor.substr(4, 2), 16)
      const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000
      return (yiq >= 160) ? '#000' : '#fff'
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-preference {
  display: flex;
  flex-direction: column;
  position: relative;

  .mobile-overlay {
    height: 100%;
    width: 100%;
    position: absolute;
    background-color: black;
    opacity: 0.45;
    z-index: 1000;
    top: 0;
    left: 0;
  }

  .preference-info-container {
    flex: 1;
    overflow: auto;
    padding: 0;

    .info-line {
      display: flex;
      padding: 30px 35px;
      border-bottom: 1px solid #eeeeee;
      align-items: center;

      .line-icon {
        color: #808080;

        i {
          font-size: 32px;
        }
      }

      .line-label {
        flex: 1;
        margin-left: 15px;
        line-height: normal;

        .preference-label {
          font-weight: bold;
          font-size: 16px;
          color: #4d4d4d;
        }

        .select-label {
          margin-top: 5px;
          color: #636363;
        }
      }

      .line-arrow {
        font-size: 20px;

        i {
          font-weight: bold;
        }
      }

      .select-option-list {
        display: none;
        width: 100%;
        background: rgba($color: #000000, $alpha: 0.7);
        text-align: center;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 2;
        transition: transform .5s ease;
        transform: translateY(100%);

        &.move-in {
          transform: translateY(0);
        }

        .option-item {
          margin: 0 35px;
          padding: 30px 0;
          border-bottom: 1px solid #808080;
          color: #fff;
          cursor: pointer;

          &:last-child {
            border: 0;
          }
        }
      }
    }
  }

  .footer-btn-group {
    display: flex;
    height: 25px;
    padding: 0 35px 20px;
    line-height: 15px;
    font-size: 14px;
    box-sizing: content-box;

    .back-btn {
      width: 45px;
      margin-left: 0;
      margin-right: auto;
      padding: 5px;
      border: 1px solid #000;
      text-align: center;
      cursor: pointer;
    }

    .next-btn {
      width: 45px;
      margin-left: auto;
      margin-right: 0;
      padding: 5px;
      text-align: center;
      cursor: pointer;
    }
  }
}
</style>
